import { PriceDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/PriceAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchPrices, FetchPricesPayload, pricesFetched, pricesFetchFailed } from '../../actions/subscription/fetchPrices';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchPricesSaga({ payload }: Action<FetchPricesPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState, feature, placeUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getPrices, token, { feature, placeUuid });
  const { prices, error } = response;
  if (!error) {
    const responsePayload = {
      prices: prices.map((price: PriceDto) => fromDto(price)),
      feature,
      placeUuid,
      timestamp,
    };
    const responseAction = pricesFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = pricesFetchFailed({ timestamp, feature, placeUuid });
    yield put(responseAction);
  }
}

export default function* watchFetchPricesSaga() {
  yield takeEvery(fetchPrices, fetchPricesSaga);
}
